import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiDashboard() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    getAirlinesLuggageCount: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "dashboard/airlines", model);
        return response.data;
      } catch (error) {
        console.error("Error fetching carriers:", error);
        throw error;
      }
    },

  };
}
